export enum AifCreationBillActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    /**
     * 生单流程编号
     */
    aifProcessCode = 'aifProcessCode',
    /**
     * VoNodePath
     */
    voNodePath = 'voNodePath',
    /**
     * isRelied
     */
    isRelied = 'isRelied',
}